// HTML templates for the Renderer class
// Extracted from Renderer.tsx for better maintainability

export const RendererTemplates = {
  // Basic overlay template for modals
  overlay: `<div class="modal-container"><div id="ovText" class="modal-title"></div><div class="modal-body"></div><button id="ovBtn" class="skeech-btn modal-button"></button></div>`,

  // Original lobby interface
  lobby: () => `
    <div class="skeech-lobby-wrap">
      <div class="skeech-lobby-header">
        <div class="logo-placeholder skeech-lobby-title">skrollrollr</div>
        <button id="lobbyProfile" class="skeech-btn profile-close-btn skeech-btn-icon">
          <img id="lobbyProfileImage" src="data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 100 100%27><circle cx=%2750%27 cy=%2750%27 r=%2750%27 fill=%27gray%27/><path d=%27M50 58c-11 0-20 9-20 20v2h40v-2c0-11-9-20-20-20zM50 24c-8.3 0-15 6.7-15 15s6.7 15 15 15 15-6.7 15-15-6.7-15-15-15z%27 fill=%27white%27/></svg>" class="profile-image" />
        </button>
      </div>

      <div class="skeech-lobby-content">
        <div class="skeech-lobby-section">          
          <div id="active-games-container"></div>
        </div>
        <div class="skeech-lobby-section">
          <h3 class="skeech-lobby-section-title">Players Online</h3>
          <div class="skeech-lobby-list" id="lobbyList" role="listbox" aria-label="Players"></div>
        </div>
      </div>

      <div class="skeech-lobby-actions">
        <button id="lobbySolo" class="skeech-btn left skeech-btn-primary">
          <div class="icon">🤖</div>
          <div class="text">AI Challenge</div>
        </button>
        <button id="lobbyTournament" class="skeech-btn skeech-btn-primary">
          <div class="icon">🏆</div>
          <div class="text">Tournament</div>
        </button>
        <button id="lobbyFindMatch" class="skeech-btn skeech-btn-primary">
          <div class="icon">🔍</div>
          <div class="text">Find a Match</div>
        </button>
      </div>
    </div>
  `,

  incomingInvite: (fromUserName: string) => `
    <div class="incoming-invite-container">
        <div class="dialog-title">Match Request</div>
        <div class="dialog-message"><strong>${fromUserName}</strong> wants a Skeech showdown. Accept?</div>
        <div class="dialog-buttons">
            <button id="invDecline" class="skeech-btn-icon">
              <div class="icon">❌</div>              
            </button>
            <button id="invAccept"  class="skeech-btn-icon">
              <div class="icon">✅</div>              
            </button>
        </div>
    </div>
  `, 

  // Profile modal template
  profile: (userName: string) => `
    <div class="skeech-profile-wrap">
      <div class="skeech-profile-header">
        <button id="profileClose" class="skeech-btn profile-close-btn skeech-btn-icon">
          <div class="icon">❌</div>          
        </button>
      </div>

      <div class="" id="profileImageSection">        
        <div class="image-pref-item" style="display: flex; flex-direction: column; align-items: center; gap: 12px;">
          <img id="profileImagePreview" src="" class="profile-image-preview" />
          <label for="profileImageInput" class="skeech-btn" style="font-size: 32px; padding: 8px 16px; cursor: pointer;">📷</label>
          <input type="file" id="profileImageInput" accept="image/*" style="display: none;">
          <div id="uploadStatus"></div>
        </div>
      </div>

      <div class="" id="usernameSection">        
        <div id="usernameDisplay" class="username-display">
          <span id="currentUsername" class="current-username">${userName}</span>
          <button id="editUsernameBtn" class="edit-username-btn skeech-btn-icon">
            <div class="icon">✏️</div>            
          </button>
        </div>
        <div id="usernameEdit" class="username-edit">
          <input type="text" id="usernameInput" class="username-input" maxlength="20" placeholder="Enter username">
          <button id="saveUsernameBtn" class="skeech-btn save-username-btn skeech-btn-icon">
            <div class="icon">💾</div>            
          </button>
          <button id="cancelUsernameBtn" class="cancel-username-btn skeech-btn-icon">
            <div class="icon">❌</div>            
          </button>
        </div>
      </div>

      

      <div class="skeech-profile-section skeech-profile-prefs">
        <details class="profile-accordion">
          <summary>
            <span class="profile-accordion-label">🎛️ Preferences</span>
            <span class="accordion-icon" aria-hidden="true">▾</span>
          </summary>
          <div id="profilePreferences" class="profile-accordion-content">
            <div class="pref-item">
              <label for="backgroundColorPicker" class="pref-label">Change background color:</label>
              <input type="color" id="backgroundColorPicker" value="#1a1a1a" class="color-picker">
              <button id="saveBackgroundColor" class="save-pref-btn skeech-btn-icon">
                <div class="icon">💾</div>              
              </button>
            </div>
            <div class="pref-item">
              <label for="ballColorPicker" class="pref-label">Change ball color:</label>
              <input type="color" id="ballColorPicker" value="#1a1a1a" class="color-picker">
              <button id="saveBallColor" class="skeech-btn save-pref-btn skeech-btn-icon">
                <div class="icon">💾</div>              
              </button>
            </div>          
          </div>
        </details>
      </div>

      <div class="skeech-profile-section skeech-profile-content">
        <details class="profile-accordion">
          <summary>
            <span class="profile-accordion-label stats-title">📊 Statistics</span>
            <span class="accordion-icon" aria-hidden="true">▾</span>
          </summary>
          <div id="profileStats" class="profile-accordion-content">
            <!-- Stats will be populated here -->
          </div>
        </details>
      </div>

      <div id="profileAchievements" class="skeech-profile-section">
        <details class="profile-accordion">
          <summary>
            <span class="profile-accordion-label achievements-title">🏆 Achievements</span>
            <span class="accordion-icon" aria-hidden="true">▾</span>
          </summary>
          <div class="profile-accordion-content">
            <div id="achievementsGrid" class="achievements-grid">
              <div class="achievement-placeholder">Loading achievements...</div>
            </div>
          </div>
        </details>
      </div>

      <div id="logoutSection" style="display: none;">
        <button id="profileLogout" class="skeech-btn skeech-btn-danger" style="width: 100%;">
          <div class="icon">🚪</div>
          <div class="text">Logout</div>
        </button>
      </div>
    </div>
  `,

  // Stats display template
  stats: {
    loading: `<div class="stats-loading">Loading stats...</div>`,

    error: `<div class="stats-error">Error loading stats</div>`,

    display: (stats: any) => `
      <div class="stats-grid">
        <div><strong>Games Played:</strong> ${stats.gamesPlayed || 0}</div>
        <div><strong>Wins:</strong> ${stats.wins || 0}</div>
        <div><strong>Losses:</strong> ${stats.losses || 0}</div>
        <div><strong>Skeeches:</strong> ${stats.numOfSkeeches || 0}</div>
        <div><strong>Total Points:</strong> ${stats.pointsTotal || 0}</div>
        <div><strong>Avg PPR:</strong> ${stats.avgPPR?.toFixed(2) || '0.00'}</div>
      </div>
    `,

    empty: `
      <div class="stats-empty">No games played yet!</div>
    `
  },

  // Presence list row template
  presenceRow: (userName: string, isOnline: boolean) => `
    <div class="presence-item">
      <div class="presence-item-inner">
        <span>${userName}</span>
        <span class="presence-status" style="color: ${isOnline ? '#4CAF50' : '#999'};">
          ${isOnline ? '🟢 Online' : '⚫ Offline'}
        </span>
      </div>
    </div>
  `,

  // Quit confirmation modal
  quitConfirmation: (opponentName: string) => `
    <div class="quit-confirm-container">
      <div class="quit-confirm-title">Your opponent's Skroll is too strong for you?</div>
      <div class="quit-confirm-body">
        You will forfeit this game. A loss. You'll be a loser. You sure?
      </div>
      <div class="quit-confirm-actions">
        <button id="confirmQuit" class="skeech-btn-icon">
          <div class="icon">🏳️</div>          
        </button>
        <button id="cancelQuit" class="skeech-btn-icon">
          <div class="icon">❌</div>          
        </button>
      </div>
    </div>
  `,

  // Forfeit notification modal
  forfeitNotification: (opponentName: string) => `    
    <div class="modal-title">You Win!</div>
    <div class="modal-body">
      <strong>${opponentName}</strong> quit!
      <div>Your skrolling is much too strong!</div>
    </div>      
    
  `,

  // Generic modal template
  modal: (title: string, body: string) => `
    <div class="modal-container">
      <div class="modal-title">${title}</div>
      <div class="modal-body">${body}</div>
      <button id="modalBtn" class="modal-button skeech-btn-icon">
        <div class="icon">✅</div>        
      </button>
    </div>
  `,

  // Match searching dialog template
  matchSearching: () => `
    <div class="modal-container">
      <div class="modal-title">Searching for Match</div>
      <div class="search-body">
        Looking for an opponent to play against...
      </div>
      <div class="search-spinner-container">
        <div class="search-spinner"></div>
      </div>
      <div id="search-actions" style="display: flex; flex-direction: row; gap: 30px; justify-content: center;">
        <button id="cancelSearchBtn" class="search-cancel-btn skeech-btn-icon">
          <div class="icon">❌</div>          
        </button>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `,

  
  // Two-button dialog template
  twoButtonDialog: (msg: string, button1Text: string, button2Text: string) => `
    <div class="two-button-dialog-container">
        <div class="dialog-message">${msg}</div>
        <div class="dialog-buttons">
            <button id="btn1" class="skeech-btn-icon">
              <div class="icon"></div>
              <div class="text">${button1Text}</div>
            </button>
            <button id="btn2" class="skeech-btn-icon">
              <div class="icon"></div>
              <div class="text">${button2Text}</div>
            </button>
        </div>
    </div>
  `,

  // End-game overlay template
  winOverlay: (title: string, subtitle: string, scoreDisplay: string, isMultiplayer: boolean, isWinner: boolean) => `
    <div class="win-overlay-container">
        <div class="win-overlay-title ${isWinner ? 'victory' : 'defeat'}">${title}</div>
        <div class="win-overlay-subtitle">${subtitle}</div>
        <div class="win-overlay-score">${scoreDisplay}</div>
        <div class="win-overlay-buttons">
            ${isMultiplayer ? '<button id="rematchBtn" class="skeech-btn skeech-btn-icon"><div class="icon">🔁</div><div class="text">Rematch</div></button>' : ''}
            <button id="playAgainBtn" class="skeech-btn skeech-btn-icon">${isMultiplayer ? '<div class="icon">🆕</div><div class="text">New Game</div>' : '<div class="icon">🔄</div><div class="text">Play Again</div>'}</button>
            ${isMultiplayer ? '<button id="lobbyBtn" class="skeech-btn skeech-btn-icon"><div class="icon">🏠</div><div class="text">Return to Lobby</div></button>' : ''}
        </div>
    </div>
  `,
  // Match introduction dialog template
  matchIntroduction: (currentPlayer: any, opponent: any, isStarting: boolean, titleText?: string, hideWL?: boolean, isAIChallenge?: boolean) => {
    const isAIMode = isAIChallenge || opponent.id === 'ai_robo_roller';
    // Hide W-L only for bracket tournaments or AI mode (round robin should show W-L)
    const shouldHideWL = hideWL || isAIMode;
    const currentPlayerStats = shouldHideWL
      ? `<div>PPR: ${currentPlayer.avgPPR?.toFixed(2) || '0.00'}</div>`
      : `<div>W-L: ${currentPlayer.wins ?? 0}-${currentPlayer.losses ?? 0}</div>
         <div>PPR: ${currentPlayer.avgPPR?.toFixed(2) || '0.00'}</div>`;

    const opponentStats = shouldHideWL
      ? `<div>PPR: ${opponent.avgPPR?.toFixed(2) || '0.00'}</div>`
      : `<div>W-L: ${opponent.wins ?? 0}-${opponent.losses ?? 0}</div>
         <div>PPR: ${opponent.avgPPR?.toFixed(2) || '0.00'}</div>`;

    return `
    <div class="match-intro-container">
      <div class="match-intro-title">${titleText || 'Match Found!'}</div>

      <div class="match-intro-players">
        <!-- Current Player -->
        <div class="match-intro-player-card">
          <div class="match-intro-player-title match-intro-player-title-you">You</div>
          <div class="match-intro-player-name">${currentPlayer.userName}</div>
          <div class="match-intro-player-stats">
            ${currentPlayerStats}
          </div>
        </div>

        <div class="match-intro-vs">VS</div>

        <!-- Opponent -->
        <div class="match-intro-player-card">
          <div class="match-intro-player-title match-intro-player-title-opponent">Opponent</div>
          <div class="match-intro-player-name">${opponent.userName}</div>
          <div class="match-intro-player-stats">
            ${opponentStats}
          </div>
        </div>
      </div>

      <div class="match-intro-starting-player-container">
        <div class="match-intro-starting-player-title">Starting Player</div>
        <div class="match-intro-starting-player-name">${isStarting ? 'You go first!' : opponent.userName + ' goes first'}</div>
      </div>

      <div class="match-intro-actions">
        <button id="cancelMatchBtn" class="match-intro-cancel-btn skeech-btn-icon">
          <div class="icon">❌</div>
          <div class="text">Cancel</div>
        </button>
        <button id="startMatchBtn" class="match-intro-start-btn skeech-btn-icon">
          <div class="icon">⚔️</div>
          <div class="text">Start Game</div>
        </button>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;
  },

  // Tournament entry screen (UI-only)
  tournamentEntry: () => `
    <div class="modal-container tournament-container">
      <div class="modal-title">Tournaments
        <button id="tournamentClose" class="skeech-btn profile-close-btn skeech-btn-icon" style="position: absolute; top: 20px; right: 20px;">
          <div class="icon">❌</div>
        </button>
      </div>

      <div class="tournament-actions">
        <button id="tourneyStartBtn" class="skeech-btn-icon tournament-start-btn" type="button">
          <div class="icon">🏆</div>
          <div class="text">Start Tournament</div>
        </button>
      </div>

      <div class="tournament-divider"><span>or</span></div>

      <div id="tourneyJoinSection" class="tournament-join">
        <label for="tourneyJoinCode" class="tournament-label">Join Tournament</label>
        <input id="tourneyJoinCode" type="text" class="tournament-input" maxlength="6" placeholder="XXXXXX" autocomplete="off" autocapitalize="characters" />
        <div id="tourneyJoinError" class="tournament-error" aria-live="polite"></div>
      </div>
      <div class="tournament-divider"><span>or</span></div>
      <div id="tourneyMySection" class="tournament-my">
        <div class="tournament-label">Your Tournaments</div>
        <div id="tourneyMyList" class="tournament-my-list"></div>
      </div>
    </div>
  `,

  // Tournament created confirmation with shareable code
  tournamentCreated: (name: string, code: string) => `
    <div class="modal-container tournament-container">
      <div class="modal-title">Tournament Created</div>
      <div class="tournament-created-name">${name}</div>
      <div class="tournament-code-wrap">
        <div class="tournament-code">${code}</div>
        <button id="copyTourneyCode" class="skeech-btn-icon copy-code-btn" type="button" title="Copy">
          <div class="icon">📋</div>
          <div class="text">Copy</div>
        </button>
      </div>
      <div class="tournament-created-help">Share this code so others can join.</div>
      <div class="tournament-created-actions">
        <button id="goTourneyLobby" class="skeech-btn-icon" type="button">
          <div class="icon">➡️</div>
          <div class="text">Go to Tournament Lobby</div>
        </button>
      </div>
      <div id="copyToast" class="copy-toast" aria-live="polite"></div>
    </div>
  `
};


